import { Checkbox, ListItem, Typography } from '@mui/material';
import { checkboxIconProps } from 'Components/CheckboxIcons';
import { Fragment } from 'react';
import { getCheckboxLabelTypography } from 'Utils/checkboxLabelTypography';

interface ICheckboxList {
  props?: any;
  option: string;
  isSelected: boolean;
  onClickCheckbox?: (value: string) => void;
}

export const CheckboxList = ({
  option,
  isSelected,
  onClickCheckbox,
  ...props
}: ICheckboxList) => {
  const optionId = option.trim().replace(' ', '-');
  const labelTypography = getCheckboxLabelTypography(isSelected);
  const { icon, checkedIcon } = checkboxIconProps();

  return (
    <Fragment key={option}>
      <ListItem
        {...props}
        sx={{
          maxHeight: '40px',
          '&:hover': {
            bgcolor: 'primary.shade_100',
            cursor: 'pointer',
          },
          '&.Mui-selected': {
            bgcolor: 'primary.shade_100',
          },
        }}
        onClick={() => (onClickCheckbox ? onClickCheckbox(option) : undefined)}
        role='option'
        aria-labelledby={optionId}
      >
        <label htmlFor={optionId}>
          <Checkbox
            aria-labelledby={optionId}
            icon={icon}
            checkedIcon={checkedIcon}
            checked={isSelected}
          />
          <Typography
            id={optionId}
            component='span'
            variant={labelTypography.variant}
            sx={labelTypography.sx}
          >
            {option}
          </Typography>
        </label>
      </ListItem>
    </Fragment>
  );
};
